import React from 'react';
import './CompanyIntro.css';

const CompanyIntro = ({ config }) => {
  return (
    <div className="company-intro">
      <div className="intro-content">
        <div className="intro-text">
          <h2 className="intro-title">{config.title}</h2>
          <p className="intro-description">
            {config.description}
          </p>
          <div className="intro-button">
            <button 
              className="about-us-btn"
              onClick={() => window.location.hash = '#why-nexus'}
            >
              <span>{config.buttonText}</span>
            </button>
          </div>
        </div>
        
        <div className="intro-image">
          <img 
            src={config.image} 
            alt="Company Introduction" 
            className="intro-img"
          />
        </div>
      </div>
    </div>
  );
};

export default CompanyIntro;
